import { SummaryConfig } from "../../../hooks";

export const alkGradingSummaryConfig: SummaryConfig = {
    epithelium: [
        {
            accessor: "epitheliumRemoved",
            renderer: "Epithelium Removed.",
        },
        {
            accessor: "traceEpithelialPresent",
            renderer: "Trace Epithelial Remnants Present.",
        },
        {
            accessor: "epitheliumComments",
        },
    ],
    stroma: [
        {
            accessor: "stroma.anteriorThickness",
            formatter: (val) => `Anterior Bed Thickness: ${val} µm.`,
        },
        {
            accessor: "stroma.size",
            formatter: (val) => `Size: ${val} mm.`,
        },
        {
            accessor: "stroma.comments",
        },
    ],
};
